export const RenderDoneSymbol = Symbol('RenderDone')
export const InternalNextRenderDoneSymbol = Symbol('InternalNextRenderDoneSymbol')
